<template>
    <div>
        <div v-cloak v-show="loading">
            <category-group-loader />
        </div>

        <div v-cloak v-show="!loading">
            <div v-cloak v-show="!emptyCategoryGroups">
                <category-group-item v-for="group in categoryGroups" :key="group.id" :group="group" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        categoryGroups: [],
        loading: false
    }),

    created() {
        this.fetchCategoryGroups();
    },

    mounted() {},

    computed: {
        emptyCategoryGroups() {
            return this.categoryGroups.length == 0;
        }
    },

    methods: {
        fetchCategoryGroups() {
            this.loading = true;

            axios
                .get("/api/categorygroups")
                .then(response => {
                    var groups = response.data;
                    this.categoryGroups = groups;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
